// Copyright (c) 2024 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { SupportAlert } from '@/components/support-alert';
import { PropsWithChildren } from 'react';
import { ErrorBoundary } from 'react-error-boundary';

interface Props {
  /**
   * A message to display in the support alert.
   */
  message: string;
}

/**
 * An error boundary that displays a support alert when an error occurs.
 */
export function SupportErrorBoundary(props: PropsWithChildren<Props>) {
  return (
    <ErrorBoundary fallback={<SupportAlert message={props.message} />}>
      {props.children}
    </ErrorBoundary>
  );
}
